const base = 'http://return-path.local';

function isUnder(pathname: string, prefix: string) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * The page to go back to after signing in, if `value` is a page on this site.
 * Other sites, API routes and the login page itself give `null`.
 */
export function parseReturnPath(value: unknown, loginPath: string): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || [...value].some((c) => c < ' ')) {
    return null;
  }

  try {
    const url = new URL(value, base);
    // Decoded, so `%2F` and `%5C` can't hide another host or the login page.
    const path = decodeURIComponent(url.pathname).replaceAll('\\', '/');
    const isPage = !path.startsWith('//') && !isUnder(path, loginPath) && !isUnder(path, '/api');
    return url.origin === base && isPage ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
}
